import React from "react";
import { CONTACTS, IMAGES } from "../../mock.de";
import { Reveal, Eyebrow, Ornament } from "../../components/bits";
import RequestDonationFlow from "../../components/RequestDonationFlow";
import { Mail, Check } from "lucide-react";

const ContactsDe = () => {
  const { hero, intro, checklist, email, dana } = CONTACTS;

  return (
    <main>
      <section className="section bloom" style={{ paddingTop: "clamp(5rem, 9vw, 8rem)" }}>
        <div className="container-page">
          <div className="contact-grid">
            {/* Left: intro + portrait + checklist */}
            <Reveal>
              <Eyebrow>Kontakt</Eyebrow>
              <h1 className="h-section" style={{ fontSize: "clamp(2rem, 4vw, 3rem)" }}>
                {hero.title}
              </h1>
              <p className="lead" style={{ marginTop: "1rem" }}>{hero.sub}</p>

              <div className="img-frame" style={{ aspectRatio: "4 / 5", maxWidth: 360, margin: "2rem 0" }}>
                <img src={IMAGES.lucaContact} alt="Dr. Ing. Luca Pizzimbone" loading="lazy" />
              </div>

              <a
                href={`mailto:${email}`}
                className="btn-ghost"
                style={{ marginBottom: "1.75rem" }}
              >
                <Mail size={16} /> {email}
              </a>

              <p style={{ color: "var(--ink-soft)", marginBottom: "1.25rem" }}>{intro}</p>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: "1rem" }}>
                {checklist.map((c) => (
                  <li key={c.title} style={{ display: "flex", gap: "0.85rem" }}>
                    <span
                      style={{
                        flex: "none",
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        display: "grid",
                        placeItems: "center",
                        background: "linear-gradient(160deg, #fbf3da, #f3e7bd)",
                        border: "1px solid var(--gold-strong)",
                        marginTop: 3,
                      }}
                    >
                      <Check size={13} color="var(--gold-ink)" />
                    </span>
                    <span>
                      <strong style={{ color: "var(--ink)", fontWeight: 600 }}>{c.title}</strong>
                      <br />
                      <span style={{ color: "var(--ink-faint)", fontSize: "0.92rem" }}>{c.desc}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </Reveal>

            {/* Right: unified Request + Donation flow */}
            <Reveal delay={120}>
              <RequestDonationFlow />
            </Reveal>
          </div>
        </div>
      </section>

      {/* Dana / Donation */}
      <section className="section" style={{ background: "var(--paper-warm)" }}>
        <div className="container-page">
          <Reveal className="container-narrow" style={{ textAlign: "center" }}>
            <Ornament style={{ marginBottom: "1.1rem", justifyContent: "center", display: "inline-flex" }} />
            <h2 className="h-section">{dana.title}</h2>
            <p className="lead" style={{ marginTop: "1.1rem" }}>{dana.intro}</p>
          </Reveal>

          <Reveal delay={100} style={{ marginTop: "2.5rem", overflowX: "auto" }} className="container-narrow">
            <table className="dana-table soft-card" style={{ overflow: "hidden" }}>
              <thead>
                <tr>
                  <th>Weg der Einstimmung</th>
                  <th>Aufbau &amp; Rhythmus</th>
                  <th>Absicht des Feldes</th>
                  <th>Wechselseitiger Beitrag (Dana)</th>
                </tr>
              </thead>
              <tbody>
                {dana.rows.map((r) => (
                  <tr key={r.path}>
                    <td data-label="Weg"><strong style={{ color: "var(--ink)" }}>{r.pathLabel}</strong></td>
                    <td data-label="Rhythmus">{r.rhythm}</td>
                    <td data-label="Absicht des Feldes">{r.intent}</td>
                    <td data-label="Dana"><span className="dana-price">{r.dana}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p style={{ color: "var(--ink-faint)", fontSize: "0.88rem", marginTop: "1.25rem", textAlign: "center" }}>
              Im Einklang mit der Tradition des Dana wird keine Sitzung jemals aufgrund fehlender Beitragsfähigkeit verweigert.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default ContactsDe;
